import React, { useRef } from 'react'
import './bbof.css'
import { useNavigate } from 'react-router-dom';
import ClickableImageCard from '../custom-components/ClickableImageCard';

function BestBrandsOnOffer() {

    const carouselRef = useRef(null);
    const navigate = useNavigate();

    const scroll = (direction) => {
      const scrollAmount = 300;
      carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    };

    const deals = [
        {id: 1, bboo: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841586718.jpg"},
        {id: 2, bboo: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841652254.jpg"},
        {id: 3, bboo: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841717790.jpg"},
        {id: 4, bboo: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841848862.jpg"},
        {id: 5, bboo: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841914398.jpg"},
        {id: 6, bboo: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588841979934.jpg"},
        {id: 7, bboo: "seven", image: "https://assets.tatacliq.com/medias/sys_master/images/63588842045470.jpg"},
        {id: 8, bboo: "eight", image: "https://assets.tatacliq.com/medias/sys_master/images/63588842111006.jpg"},
    ];

    const handleImageClick = (deal) => {
        // For now using hardcoded routes
        // Later will use deal.id or other identifier from API
        navigate(`/category/${deal.id}`);
        
        // Future API implementation might look like:
        // navigate(`/product/${deal.id}`);
        // or
        // navigate(`/category/${deal.categoryId}`);
      };


  return (
    <div className="carousel-container">
      <div className="carousel-controls justify-content-end mb-5">
          <button onClick={() => scroll('left')} className="control-button">
            &lt;
          </button>
          <button onClick={() => scroll('right')} className="control-button">
            &gt;
          </button>
        </div>
      
      <div className="image-carousel" ref={carouselRef}>
        {deals.map((deal) => (
          <ClickableImageCard key={deal.id} item={deal} />
        ))}
      </div>
    </div>
  );
}

export default BestBrandsOnOffer